import React from 'react';
import { useBoutique } from '../context/BoutiqueContext';
import { useAuth } from '../context/AuthContext';
import { Store, ChevronDown } from 'lucide-react';
import './BoutiqueSelector.css';

const BoutiqueSelector = ({ showAllOption = true }) => {
  const { user } = useAuth();
  const { boutiques, selectedBoutiqueId, selectBoutique, loading } = useBoutique();

  // Rôles qui peuvent voir toutes les boutiques
  const canSelectAll = showAllOption && ['super-admin', 'admin-entreprise'].includes(user?.role);

  // Rôles qui ont une boutique fixe (ne peuvent pas changer)
  const hasFixedBoutique = ['admin-boutique', 'gestionnaire', 'caissier'].includes(user?.role);

  if (loading) {
    return (
      <div className="boutique-selector loading">
        <Store size={18} />
        <span>Chargement...</span>
      </div>
    );
  }

  if (hasFixedBoutique) {
    const boutique = boutiques.find(b => b._id === user.boutiqueId);
    return (
      <div className="boutique-selector fixed">
        <Store size={18} />
        <span>{boutique?.nom || 'Ma boutique'}</span>
      </div>
    );
  }

  return (
    <div className="boutique-selector">
      <Store className="icon" size={18} />
      <select
        value={selectedBoutiqueId}
        onChange={(e) => selectBoutique(e.target.value)}
        className="boutique-select"
      >
        {canSelectAll && (
          <option value="all">📊 Toutes les boutiques</option>
        )}
        {boutiques.map((boutique) => (
          <option key={boutique._id} value={boutique._id}>
            {boutique.principale && '⭐ '}{boutique.nom}
            {boutique.actif === false && ' (Inactive)'}
          </option>
        ))}
      </select>
      <ChevronDown className="chevron" size={16} />
    </div>
  );
};

export default BoutiqueSelector;
